/**
 * GitHub OAuth Callback — opened in a popup window.
 * Sends a postMessage to the opener (parent window) and closes itself.
 */
import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

export default function GitHubCallback() {
  const [params] = useSearchParams();
  const projectId = params.get('projectId');
  const connected = params.get('connected') === 'true';
  const error = params.get('error');

  useEffect(() => {
    // Notify the parent window (the import modal) that GitHub auth is done
    if (window.opener) {
      window.opener.postMessage(
        {
          type: 'github-oauth-callback',
          projectId,
          connected,
          error: error || null,
        },
        window.location.origin
      );
      // Close popup after a short delay
      setTimeout(() => window.close(), 500);
    }
  }, [projectId, connected, error]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50">
      <div className="text-center">
        {connected ? (
          <>
            <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-green-100">
              <svg
                className="h-6 w-6 text-green-600"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>
            <p className="text-lg font-medium text-gray-900">GitHub Connected!</p>
            <p className="mt-1 text-sm text-gray-500">This window will close automatically...</p>
          </>
        ) : error ? (
          <>
            <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-red-100">
              <svg
                className="h-6 w-6 text-red-600"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </div>
            <p className="text-lg font-medium text-gray-900">Connection Failed</p>
            <p className="mt-1 text-sm text-red-600">{error}</p>
          </>
        ) : (
          <>
            <div className="mx-auto mb-4 h-8 w-8 animate-spin rounded-full border-4 border-gray-200 border-t-gray-600" />
            <p className="text-sm text-gray-500">Connecting to GitHub...</p>
          </>
        )}
      </div>
    </div>
  );
}
